export default function getNodes(arr: any, asKey: string) {
  if (!arr) return

  return arr.map((node: any, i: number) => {
    const newNode = { ...node }
    newNode.key = node?.[asKey]
    return newNode
  })
}
